import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { map } from 'lodash/collection';

import useAppInfo from '../../../common/hooks/useAppInfo';
import LoadingOverlay from '../../../components/LoadingOverlay/LoadingOverlay';
import { resolveLanguages } from '../../../services/i18n/languages';

export function MUILanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const { features } = useAppInfo();
  const notUsInstance = features.notUsInstance;
  const languages = useMemo(() => map(resolveLanguages(notUsInstance), (name, code) => ({ code, name })), [
    notUsInstance
  ]);

  return (
    <FormControl size="small" sx={{ minWidth: 120 }} title={t('changeLanguage')}>
      <Select
        size="small"
        variant="outlined"
        value={i18n.language}
        onChange={handleLanguageChange}
        displayEmpty
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent'
          }
        }}
        renderValue={function(value) {
          return (value || '').toUpperCase();
        }}
      >
        {languages.map(lang => (
          <MenuItem key={lang.code} value={lang.code}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2">{lang.name}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  function handleLanguageChange(event) {
    LoadingOverlay.showLoader();
    i18n.changeLanguage(event.target.value);
    setTimeout(function() {
      window.location.reload();
    });
  }
}
